import { DetalhesFiltrosModel } from "@/models/detalhesFiltrosModel";
import { SorteioModel } from "@/models/sorteio/sorteioModel";
import { buscarPlanoContaFinanceiro } from "@/services/planoContaFinanceiroService";
import { findNodeById } from "@/util/functions/findNodeById";
import { BackwardOutlined, CheckCircleOutlined, MoreOutlined, PlusCircleOutlined, SendOutlined, StopOutlined } from "@ant-design/icons";
import { Button, Col, Collapse, Drawer, Dropdown, Flex, Form, Image, List, MenuProps, Modal, Radio, RadioChangeEvent, Row, Select, Tag, Tooltip, Typography } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import * as Icon from "phosphor-react";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ButtonComponent } from "../../components/button/cadastrar";
import MensagemModal from "../../components/modal/mensagem";
import AcoesComponent from "../../components/table/acoesComponent";
import TableComponent from "../../components/table/tableComponent";
import { EmpresaModel } from "../../models/empresa/empresaModel";
import { AtualizarResultadoSorteioStatusModel } from "../../models/resultadoSorteio/atualizarResultadoSorteioStatusModel";
import { ResultadoSorteioDadosModel } from "../../models/resultadoSorteio/resultadoSorteioDadosModel";
import { ResumoModel } from "../../models/resultadoSorteio/resumoModel";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import { adicionarFiltro, adicionarFiltroFormatado, setIdEmpresaPermissao, setSubTitle, setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import {
  resetOnRadioChange,
  setBuscaResultadoSorteio,
  setComesFromResultado,
  setDataSorteio,
  setIdEmpresa,
  setIdSorteio,
  setModalAtencaoResultadoSorteio,
  setModalContasComsaldoResultadoSorteio,
  setModalHistoricoResultadoSorteio,
  setModalReiniciarResultadoSorteio,
  setPlanoContaFinanceiro,
} from "../../redux/slices/resultadoSorteio/resultadoSorteioSlice";
import { buscarEmpresa } from "../../services/empresaService";
import {
  atualizarResultadoSorteioStatus,
  buscarResultadoSorteio,
  calcularDados,
  carregarDados,
  detalhaResultadoSorteio,
  listarResumo,
  listarStatusResultadoSorteio,
  reiniciarResultado,
} from "../../services/resultadoSorteioService";
import { atualizarValorBonificacao, listarSorteio } from "../../services/sorteioService";
import { currencyBRL, formatFator, formatNumber, formatPercentCG } from "../../util/dinheiroBRAuxiliar";
import { removeFilhos } from "../../util/functions/removeFilhos";
import { verificarPermissaoEmpresa } from "../../util/functions/verificarPermissaoEmpresa";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import { toastWarning } from "../../util/toast";
import EditarBonificacaoModal, { ValoresBonificacaoForm } from "./modals/bonificacao";
import ContasComSaldoModal from "./modals/contasComSaldo";
import HistoricoResultado from "./modals/historico";
import StepsResultado from "./modals/steps";
import "./style/index.scss";

dayjs.locale("pt-br");

const { Panel } = Collapse;

const { Text } = Typography;

const ResultadoSorteio = () => {
  //estados globais
  const resultadoSorteioState = useAppSelector((state) => state.resultadoSorteio);
  const empresaState = useAppSelector((state) => state.empresa);
  const persistedState = useAppSelector((state) => state.persisted);
  const sorteioState = useAppSelector((state) => state.sorteio);
  const planoContaFinanceiroState = useAppSelector((state) => state.planoContaFinanceiro);

  //hooks
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  //estados locais
  const [form] = Form.useForm<any>();
  const [CG, setCG] = useState<any[]>([]);
  const [resumo, setResumo] = useState<any[]>([]);
  const [tipoResultado, setTipoResultado] = useState("E");
  const [openSteps, setOpenSteps] = useState<boolean>(false);
  const [modalBonificacaoAberto, setModalBonificacaoAberto] = useState<boolean>(false);
  const [salvandoBonificacao, setSalvandoBonificacao] = useState<boolean>(false);
  const [formBonificacao] = Form.useForm<ValoresBonificacaoForm>();

  const radioOptions = [
    { label: "PONTO DE EQUILÍBRIO", value: "E" },
    { label: "RESULTADO PARCIAL", value: "P" },
    { label: "RESULTADO FINAL", value: "R" },
  ];

  const isFinanceiroBase = persistedState.user.perfil === "FINANCEIRO BASE";

  const valorBonificacaoAtual = useMemo(() => {
    if (resultadoSorteioState.idSorteio === null) {
      return null;
    }

    const sorteioSelecionado = sorteioState.list.find((item: SorteioModel) => item.id === resultadoSorteioState.idSorteio);
    const valor = sorteioSelecionado?.valorBonificacao ?? sorteioState.entity?.valorBonificacao ?? null;

    if (typeof valor === "number") {
      return valor;
    }

    // if (typeof valor === "string" && valor.trim() !== "") {
    //   return realParaNumber(valor);
    // }

    return null;
  }, [resultadoSorteioState.idSorteio, sorteioState.list, sorteioState.entity]);

  const podeEditarBonificacao = useMemo(() => {
    return (tipoResultado === "E" || tipoResultado === "P") && resultadoSorteioState.idSorteio !== null;
  }, [tipoResultado, resultadoSorteioState.idSorteio, valorBonificacaoAtual]);

  const abrirModalBonificacao = () => {
    if (!podeEditarBonificacao) {
      toastWarning("Selecione um sorteio válido para editar o valor de bonificação");
      return;
    }
    formBonificacao.setFieldsValue({ valorBonificacao: valorBonificacaoAtual ?? null });
    setSalvandoBonificacao(false);
    setModalBonificacaoAberto(true);
  };

  const menuAcoesItems = useMemo<MenuProps["items"]>(
    () => [
      {
        key: "editarBonificacao",
        label: "Editar valor de bonificação",
        disabled: !podeEditarBonificacao,
      },
    ],
    [podeEditarBonificacao]
  );

  const todasAcoesDesabilitadas = useMemo(() => {
    return (menuAcoesItems ?? []).every((item) => (item as any)?.disabled);
  }, [menuAcoesItems]);

  const handleMenuAcoesClick: MenuProps["onClick"] = ({ key }) => {
    if (key === "editarBonificacao") {
      abrirModalBonificacao();
    }
  };

  useEffect(() => {
    dispatch(setTitle("RESULTADO DO SORTEIO"));
    changeSubtitle(tipoResultado);
    dispatch(buscarEmpresa(empresaState.busca));
    dispatch(listarStatusResultadoSorteio());
    if (planoContaFinanceiroState.list.length === 0) dispatch(buscarPlanoContaFinanceiro(planoContaFinanceiroState.busca));

    if (persistedState.user.empresa?.idEmpresa) {
      dispatch(listarSorteio(persistedState.user.empresa?.idEmpresa.toString()));
    } else {
      if (resultadoSorteioState.idSorteio !== null) {
        dispatch(listarSorteio(resultadoSorteioState.idEmpresa.toString()));
        var busca = { ...resultadoSorteioState.busca };
        busca.idSorteio = resultadoSorteioState.idSorteio;
        carregarResumo(busca);
      }
    }
    form.setFieldsValue({
      idSorteio: resultadoSorteioState.idSorteio,
      idEmpresa: resultadoSorteioState.idEmpresa === 0 ? null : resultadoSorteioState.idEmpresa,
    });
  }, [tipoResultado]);

  const changeSubtitle = (value: string) => {
    if (value === "E") {
      dispatch(setSubTitle("PONTO DE EQUILÍBRIO"));
    }
    if (value === "P") {
      dispatch(setSubTitle("RESULTADO PARCIAL"));
    }
    if (value === "R") {
      dispatch(setSubTitle("RESULTADO FINAL"));
    }
  };

  const onChangeRadio = ({ target: { value } }: RadioChangeEvent) => {
    changeSubtitle(value);
    let busca: ResultadoSorteioDadosModel = { ...resultadoSorteioState.busca, tipoCalculoResultado: value };

    dispatch(setBuscaResultadoSorteio(busca));
    setTipoResultado(value);
    dispatch(resetOnRadioChange());
    carregar(resultadoSorteioState.idSorteio, value);
  };

  const onChangeEmpresa = (value: string) => {
    dispatch(setIdEmpresaPermissao(value));

    setCG([]);
    setResumo([]);
    dispatch(resetOnRadioChange());

    dispatch(setIdSorteio(null));

    form.resetFields(["idSorteio"]);

    dispatch(setIdEmpresa(value));
    dispatch(listarSorteio(value.toString()));
  };

  const onChangeSorteio = async (value: any) => {
    setCG([]);
    setResumo([]);
    dispatch(resetOnRadioChange());
    const sorteio = sorteioState.listSorteioEmpresas.find((a: any) => a.idSorteio === value);
    var dataSorteio = sorteio ? sorteio.dataSorteio : null;
    dispatch(setDataSorteio(dataSorteio));
    dispatch(setIdSorteio(value));
    const retorno = await dispatch(buscarResultadoSorteio(value));
    if (retorno.payload.length !== 0) {
      carregar(value, tipoResultado);
    }
  };

  const carregarResumo = async (busca: any) => {
    const retorno = await dispatch(listarResumo(busca));
    const resumoCG = retorno.payload.filter((a: ResumoModel) => a.grupo === "CG");
    const resumoPonto = retorno.payload.filter((a: ResumoModel) => a.grupo === "PontoEquilibrio");
    if (resumoCG.length === 0 || resumoPonto.length === 0) {
      return;
    }
    setCG([
      {
        title: resumoCG[0].denominacao,
        content: resumoCG[0].valor,
        rawValue: resumoCG[0].valor,
      },
      {
        title: resumoCG[1].denominacao,
        content: currencyBRL(resumoCG[1].valor),
        rawValue: resumoCG[1].valor,
      },
      {
        title: resumoCG[2].denominacao,
        content: currencyBRL(resumoCG[2].valor),
        rawValue: resumoCG[2].valor,
      },
      {
        title: resumoCG[3].denominacao,
        content: formatNumber(resumoCG[3].valor),
        rawValue: resumoCG[3].valor,
      },
      {
        title: resumoCG[4].denominacao,
        content: formatFator(resumoCG[4].valor),
        rawValue: resumoCG[4].valor,
      },
      {
        title: resumoCG[5].denominacao,
        content: formatPercentCG(resumoCG[5].valor),
        rawValue: resumoCG[5].valor,
      },
      {
        title: resumoCG[6].denominacao,
        content: formatPercentCG(resumoCG[6].valor),
        rawValue: resumoCG[6].valor,
      },
      {
        title: resumoCG[7].denominacao,
        content: formatPercentCG(resumoCG[7].valor),
        rawValue: resumoCG[7].valor,
      },
    ]);
    setResumo([
      {
        title: resumoPonto[0].denominacao,
        content: currencyBRL(resumoPonto[0].valor),
        rawValue: resumoPonto[0].valor,
      },
      {
        title: resumoPonto[1].denominacao,
        content: formatNumber(resumoPonto[1].valor),
        rawValue: resumoPonto[1].valor,
      },
      {
        title: resumoPonto[2].denominacao,
        content: currencyBRL(resumoPonto[2].valor),
        rawValue: resumoPonto[2].valor,
      },
      {
        title: resumoPonto[3].denominacao,
        content: currencyBRL(resumoPonto[3].valor),
        rawValue: resumoPonto[3].valor,
      },
      {
        title: resumoPonto[4].denominacao,
        content: formatNumber(resumoPonto[4].valor),
        rawValue: resumoPonto[4].valor,
      },
      {
        title: resumoPonto[5].denominacao,
        content: currencyBRL(resumoPonto[5].valor),
        rawValue: resumoPonto[5].valor,
      },
      {
        title: resumoPonto[6].denominacao,
        content: currencyBRL(resumoPonto[6].valor),
        rawValue: resumoPonto[6].valor,
      },
    ]);
  };

  const calcular = () => {
    if (resultadoSorteioState.idSorteio !== null) {
      if (tipoResultado === "P" && resultadoSorteioState.resultadoSorteio.length !== 0 && resultadoSorteioState.resultadoSorteio[0].idStatusResultadoSorteio !== 7) {
        dispatch(setModalAtencaoResultadoSorteio(true));
      } else if (tipoResultado === "R" && resultadoSorteioState.resultadoSorteio.length !== 0 && resultadoSorteioState.resultadoSorteio[0].idStatusResultadoSorteio === 7) {
        dispatch(setModalContasComsaldoResultadoSorteio(true));
      } else {
        let busca: ResultadoSorteioDadosModel = { ...resultadoSorteioState.busca, idSorteio: resultadoSorteioState.idSorteio, tipoCalculoResultado: tipoResultado };

        dispatch(calcularDados({ value: busca }));
        carregar(resultadoSorteioState.idSorteio, tipoResultado);
      }
    } else {
      toastWarning("Escolha a data do sorteio");
    }
  };

  const fecharModalBonificacao = () => {
    formBonificacao.resetFields();
    setSalvandoBonificacao(false);
    setModalBonificacaoAberto(false);
  };

  const salvarBonificacao = async () => {
    if (resultadoSorteioState.idSorteio === null) {
      toastWarning("Escolha a data do sorteio");
      return;
    }

    try {
      const { valorBonificacao } = await formBonificacao.validateFields();

      if (valorBonificacao === null || valorBonificacao === undefined || Number.isNaN(valorBonificacao)) {
        toastWarning("Informe um valor de bonificação válido");
        return;
      }

      setSalvandoBonificacao(true);
      await dispatch(
        atualizarValorBonificacao({
          idSorteio: resultadoSorteioState.idSorteio,
          valorBonificacao,
        })
      ).unwrap();
      formBonificacao.resetFields();
      setModalBonificacaoAberto(false);
      carregar(resultadoSorteioState.idSorteio, tipoResultado);
    } catch (error: any) {
      if (error?.errorFields) {
        return;
      }
      // O thunk já exibe as mensagens de erro via toast
    } finally {
      setSalvandoBonificacao(false);
    }
  };

  const calcularResultadoFinal = async () => {
    let busca: ResultadoSorteioDadosModel = { ...resultadoSorteioState.busca, idSorteio: resultadoSorteioState.idSorteio, tipoCalculoResultado: "R" };

    changeSubtitle("R");
    setTipoResultado("R");
    dispatch(setBuscaResultadoSorteio(busca));
    dispatch(resetOnRadioChange());
    await dispatch(calcularDados(busca));
    carregar(resultadoSorteioState.idSorteio, "R");
  };

  const carregar = (idSorteio: number | null, tipoResultado: string) => {
    if (idSorteio !== null) {
      var busca = { ...resultadoSorteioState.busca };
      busca.idSorteio = idSorteio;
      busca.tipoCalculoResultado = tipoResultado;
      dispatch(carregarDados(busca));
      carregarResumo(busca);
      dispatch(buscarResultadoSorteio(busca.idSorteio));
    } else {
      toastWarning("Escolha a data do sorteio");
    }
  };

  const aplicar = () => {
    if (resultadoSorteioState.idSorteio !== null) {
      let args: AtualizarResultadoSorteioStatusModel = {
        idSorteio: resultadoSorteioState.idSorteio,
        idStatusResultadoSorteio: isFinanceiroBase ? (tipoResultado === "E" ? 3 : 5) : tipoResultado === "E" ? 4 : 6,
        tipoCalculoResultado: tipoResultado,
      };
      dispatch(atualizarResultadoSorteioStatus({ value: args, busca: resultadoSorteioState.idSorteio }));
      carregar(resultadoSorteioState.idSorteio, tipoResultado);
    } else {
      toastWarning("Escolha a data do sorteio");
    }
  };

  const rejeitar = () => {
    if (resultadoSorteioState.idSorteio !== null) {
      let args: AtualizarResultadoSorteioStatusModel = {
        idSorteio: resultadoSorteioState.idSorteio,
        idStatusResultadoSorteio: tipoResultado === "E" ? 2 : 4,
        tipoCalculoResultado: tipoResultado,
      };
      dispatch(atualizarResultadoSorteioStatus({ value: args, busca: resultadoSorteioState.idSorteio }));

      carregar(resultadoSorteioState.idSorteio, tipoResultado);
    } else {
      toastWarning("Escolha a data do sorteio");
    }
  };

  const goContas = (value: any) => {
    if (value.idPlanoContaFinanceiro !== 0) {
      var planoContaFinanceiro = findNodeById(planoContaFinanceiroState.list, value.idPlanoContaFinanceiro);
      if (planoContaFinanceiro) {
        var filtros: DetalhesFiltrosModel = {
          campo: "PlanoContaFinanceiro",
          operador: "Igual",
          valor: resultadoSorteioState.planoContaFinanceiro?.denominacao,
        } as DetalhesFiltrosModel;
        var filtrosFormatado: DetalhesFiltrosModel = {
          campo: "PlanoContaFinanceiro",
          operador: "EQ",
          valor: resultadoSorteioState.planoContaFinanceiro?.id,
        } as DetalhesFiltrosModel;

        dispatch(adicionarFiltro(filtros));
        dispatch(adicionarFiltroFormatado(filtrosFormatado));
        dispatch(setPlanoContaFinanceiro({ id: planoContaFinanceiro.id, denominacao: planoContaFinanceiro.denominacao }));
        dispatch(setComesFromResultado(true));
        dispatch(setSubTitle(""));
        navigate("/contaPagar");
      }
    }
  };

  const goHistorico = (value: any) => {
    dispatch(detalhaResultadoSorteio({ idSorteio: resultadoSorteioState.idSorteio, codigo: value.codigo, tipoCalculoResultado: tipoResultado }));
    dispatch(setModalHistoricoResultadoSorteio(true));
  };

  const closeModalHistorico = () => {
    dispatch(setModalHistoricoResultadoSorteio(false));
  };

  const closeModalAtencao = () => {
    dispatch(setModalAtencaoResultadoSorteio(false));
  };

  const closeModalContasComSaldo = () => {
    dispatch(setModalContasComsaldoResultadoSorteio(false));
  };

  const goComposicao = () => {
    if (resultadoSorteioState.idSorteio !== null) {
      dispatch(setComesFromResultado(true));
      dispatch(setSubTitle(""));
      navigate("/composicao");
    } else {
      toastWarning("Escolha a data do sorteio");
    }
  };

  const goReiniciar = () => {
    if (resultadoSorteioState.idSorteio !== null) {
      dispatch(setModalReiniciarResultadoSorteio(true));
    } else {
      toastWarning("Escolha a data do sorteio");
    }
  };

  const closeModalReiniciar = () => {
    dispatch(setModalReiniciarResultadoSorteio(false));
  };

  const onCloseSteps = () => {
    setOpenSteps(false);
  };

  const items: ItemMenuAcoes[] = [
    {
      label: " Ir para contas a pagar",
      key: "1",
      icon: <Icon.ArrowSquareIn size={16} color="#212937" weight="light" />,
      function: (item: any) => goContas(item),
    },
    {
      label: " Ver Detalhes",
      key: "2",
      icon: <Icon.ChartLine size={16} color="#212937" weight="light" />,
      function: (item: any) => goHistorico(item),
    },
  ];

  const columns: ColumnsType<any> = [
    {
      title: "DENOMINAÇÃO",
      dataIndex: "denominacao",
    },
    {
      title: "VALOR",
      dataIndex: "valor",
      align: "right",
      render: (_, record) => currencyBRL(record.valor),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 25,
      render: (_, record) => record.sinteticoAnalitico === "A" && record.idPlanoContaFinanceiro !== 0 && record.valor !== 0 && <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={16}>
            <Flex justify="space-between" gap={12}>
              <Form.Item name="tipoResultado" label="Visualizar">
                <Tooltip title={resultadoSorteioState.resultadoSorteio.length === 0 ? "Selecione um sorteio calculado" : ""}>
                  <Radio.Group
                    options={radioOptions}
                    onChange={onChangeRadio}
                    value={tipoResultado}
                    optionType="button"
                    buttonStyle="solid"
                    className="radioTipoResultado"
                    disabled={resultadoSorteioState.resultadoSorteio.length === 0}
                  />
                </Tooltip>
              </Form.Item>
              {tipoResultado === "R" &&
                resultadoSorteioState.resultadoSorteio.length !== 0 &&
                resultadoSorteioState.resultadoSorteio[0].idStatusResultadoSorteio > 5 &&
                resultadoSorteioState.resultadoSorteio[0].idStatusResultadoSorteio !== 7 && (
                  <Form.Item label=" ">
                    <Button type="primary" icon={<SendOutlined />} onClick={goComposicao} disabled={resultadoSorteioState.loading}>
                      VER COMPOSIÇÃO
                    </Button>
                  </Form.Item>
                )}
            </Flex>
          </Col>
          <Col span={8}>
            <Form.Item name="situacao" label=" ">
              <Flex justify="space-between" align="center">
                <span>SITUAÇÃO:</span>
                <Tag style={{ cursor: "pointer" }} onClick={() => setOpenSteps(true)}>
                  {resultadoSorteioState.idSorteio !== null
                    ? resultadoSorteioState.resultadoSorteio.length !== 0
                      ? resultadoSorteioState.resultadoSorteio[0].denominacao
                      : "Resultado não calculado"
                    : ""}
                </Tag>
              </Flex>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12} align="bottom">
          <Col span={12}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item name="idEmpresa" label="Empresa">
                  <Select
                    showSearch
                    optionFilterProp="labelSearch"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: 300 }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item label="Data do sorteio" name="idSorteio">
                <Select
                  showSearch
                  optionFilterProp="label"
                  style={{ width: 140 }}
                  loading={sorteioState.loadingEmpresas}
                  disabled={resultadoSorteioState.loading}
                  options={sorteioState.listSorteioEmpresas.map((a: any) => ({
                    value: a.idSorteio,
                    label: dayjs(a.dataSorteio).format("DD/MM/YYYY"),
                  }))}
                  onChange={onChangeSorteio}
                />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end" gap={12}>
              <Form.Item label=" ">
                <Tooltip title={"Ações"}>
                  <Dropdown menu={{ items: menuAcoesItems, onClick: handleMenuAcoesClick }} trigger={["click"]}>
                    <Button icon={<MoreOutlined />} disabled={todasAcoesDesabilitadas}></Button>
                  </Dropdown>
                </Tooltip>
              </Form.Item>
              {!isFinanceiroBase && verificarPermissaoEmpresa() && (
                <Tooltip title={"Reiniciar resultado do sorteio"}>
                  <Form.Item label=" ">
                    <Button icon={<BackwardOutlined />} onClick={goReiniciar} />
                  </Form.Item>
                </Tooltip>
              )}
              <ButtonComponent className="addButtonConta buttonPrimary" onClick={calcular} icon={<PlusCircleOutlined />}>
                CALCULAR
              </ButtonComponent>
            </Flex>
          </Col>
          <Col span={8}>
            <Flex justify="end">
              {tipoResultado !== "P" && (
                <>
                  {!isFinanceiroBase ? (
                    <>
                      {Object.keys(resultadoSorteioState.resultadoSorteio).length === 0 ||
                        (resultadoSorteioState.resultadoSorteio.length !== 0 &&
                          ((resultadoSorteioState.resultadoSorteio[0].idStatusResultadoSorteio === 3 && tipoResultado === "E") ||
                            (resultadoSorteioState.resultadoSorteio[0].idStatusResultadoSorteio === 5 && tipoResultado === "R")) && (
                            <Flex gap={8}>
                              <ButtonComponent className="addButtonConta" onClick={rejeitar} icon={<StopOutlined />}>
                                REJEITAR
                              </ButtonComponent>
                              <ButtonComponent className="addButtonConta buttonPrimary" onClick={aplicar} icon={<CheckCircleOutlined />}>
                                APROVAR
                              </ButtonComponent>
                            </Flex>
                          ))}
                    </>
                  ) : (
                    <>
                      {Object.keys(resultadoSorteioState.resultadoSorteio).length === 0 ||
                        (resultadoSorteioState.resultadoSorteio.length !== 0 &&
                          ((resultadoSorteioState.resultadoSorteio[0].idStatusResultadoSorteio === 2 && tipoResultado === "E") ||
                            (resultadoSorteioState.resultadoSorteio[0].idStatusResultadoSorteio === 7 && tipoResultado === "R")) && (
                            <ButtonComponent className="addButtonConta buttonPrimary" onClick={aplicar} icon={<CheckCircleOutlined />}>
                              CONCLUIR
                            </ButtonComponent>
                          ))}
                    </>
                  )}
                </>
              )}
            </Flex>
          </Col>
        </Row>
      </Form>
      <Row gutter={12} className="dados">
        <Col span={16}>
          <div className="leftHeader">
            <span>DESPESAS TOTAIS</span>
          </div>
          <Collapse defaultActiveKey={["1", "2", "3"]}>
            <Panel
              header={
                <Flex justify="space-between">
                  <span>ENTIDADE</span>
                  <span>
                    {currencyBRL(
                      Object.keys(resultadoSorteioState.resultado).length !== 0 && resultadoSorteioState.resultado.entidade.length !== 0 ? resultadoSorteioState.resultado.entidade[0].valor : 0
                    )}
                  </span>
                </Flex>
              }
              key="1"
              style={{ marginBottom: 10 }}
            >
              <TableComponent
                loading={resultadoSorteioState.loading}
                columns={columns}
                data={
                  Object.keys(resultadoSorteioState.resultado).length !== 0 && resultadoSorteioState.resultado.entidade.length !== 0
                    ? removeFilhos(resultadoSorteioState.resultado.entidade[0].filhos)
                    : []
                }
                rowKey="codigo"
                expandable={{
                  childrenColumnName: "filhos",
                  expandRowByClick: true,
                }}
                pagination={false}
                tableProps={{
                  showHeader: false,
                  bordered: true,
                  className: "tableCentroCusto",
                }}
              />
            </Panel>
            <Panel
              header={
                <Flex justify="space-between">
                  <span>CAPITALIZAÇÃO</span>
                  <span>
                    {currencyBRL(
                      Object.keys(resultadoSorteioState.resultado).length !== 0 && resultadoSorteioState.resultado.capitalizacao.length !== 0
                        ? resultadoSorteioState.resultado.capitalizacao[0].valor
                        : 0
                    )}
                  </span>
                </Flex>
              }
              key="2"
              style={{ marginBottom: 10 }}
            >
              <TableComponent
                loading={resultadoSorteioState.loading}
                columns={columns}
                data={
                  Object.keys(resultadoSorteioState.resultado).length !== 0 && resultadoSorteioState.resultado.capitalizacao.length !== 0
                    ? removeFilhos(resultadoSorteioState.resultado.capitalizacao[0].filhos)
                    : []
                }
                rowKey="codigo"
                expandable={{
                  childrenColumnName: "filhos",
                  expandRowByClick: true,
                }}
                pagination={false}
                tableProps={{
                  showHeader: false,
                  bordered: true,
                  className: "tableCentroCusto",
                }}
              />
            </Panel>
            <Panel
              header={
                <Flex justify="space-between">
                  <span>ADMINISTRATIVAS - PROMOBEM / 4WAYS</span>
                  <span>
                    {currencyBRL(
                      Object.keys(resultadoSorteioState.resultado).length !== 0 && resultadoSorteioState.resultado.promobem.length !== 0 ? resultadoSorteioState.resultado.promobem[0].valor : 0
                    )}
                  </span>
                </Flex>
              }
              key="3"
            >
              <TableComponent
                loading={resultadoSorteioState.loading}
                columns={columns}
                data={
                  Object.keys(resultadoSorteioState.resultado).length !== 0 && resultadoSorteioState.resultado.promobem.length !== 0
                    ? removeFilhos([...resultadoSorteioState.resultado.promobem[0].filhos, resultadoSorteioState.resultado.promobem[1], resultadoSorteioState.resultado.promobem[2]])
                    : []
                }
                rowKey="codigo"
                expandable={{
                  childrenColumnName: "filhos",
                  expandRowByClick: true,
                }}
                pagination={false}
                tableProps={{
                  showHeader: false,
                  bordered: true,
                  className: "tableCentroCusto",
                }}
              />
            </Panel>
          </Collapse>
        </Col>
        <Col span={8}>
          <div className="rightHeader"></div>
          <Collapse defaultActiveKey={["1", "2"]} className="resumo">
            <Panel header={tipoResultado === "E" ? "PONTO DE EQUILÍBRIO" : tipoResultado === "P" ? "RESULTADO PARCIAL" : "RESULTADO FINAL"} key="1">
              <List
                loading={resultadoSorteioState.loading}
                className="listCG"
                dataSource={resumo}
                itemLayout="horizontal"
                renderItem={(item, index) => (
                  <List.Item key={index}>
                    <Tooltip title={item.title.length > 15 ? item.title.toUpperCase() : ""}>
                      <List.Item.Meta title={item.title.toUpperCase()} />
                    </Tooltip>
                    <div className="listItemContent">{item.content}</div>
                  </List.Item>
                )}
              />
            </Panel>
            <Panel header="PARÂMETROS DA C.G" key="2">
              <List
                loading={resultadoSorteioState.loading}
                className="listCG"
                dataSource={CG}
                itemLayout="horizontal"
                renderItem={(item, index) => (
                  <List.Item key={index}>
                    <Tooltip title={item.title.length > 15 ? item.title.toUpperCase() : ""}>
                      <List.Item.Meta title={item.title.toUpperCase()} />
                    </Tooltip>
                    <div className="listItemContent">{item.content}</div>
                  </List.Item>
                )}
              />
            </Panel>
          </Collapse>
        </Col>
      </Row>
      <Modal title={"EDITAR VALOR DE BONIFICAÇÃO"} open={modalBonificacaoAberto} onCancel={fecharModalBonificacao} footer={null} destroyOnClose>
        <EditarBonificacaoModal form={formBonificacao} valorBonificacaoAtual={valorBonificacaoAtual} onCancel={fecharModalBonificacao} onSubmit={salvarBonificacao} salvando={salvandoBonificacao} />
      </Modal>
      <Modal title={"DETALHES RESULTADO"} centered width={1100} open={resultadoSorteioState.modalHistorico} onCancel={closeModalHistorico} footer={null} destroyOnHidden>
        <HistoricoResultado />
      </Modal>
      <Modal title={"ATENÇÃO"} centered width={330} open={resultadoSorteioState.modalAtencao} onCancel={closeModalAtencao} footer={null} destroyOnHidden>
        <Text style={{ fontSize: 16 }}>Não é possível calcular o resultado do sorteio desejado, pois as vendas ainda não foram processadas</Text>
      </Modal>
      <Modal
        title={"REINICIAR RESULTADO DO SORTEIO"}
        afterClose={() => carregar(resultadoSorteioState.idSorteio, "E")}
        centered
        width={330}
        open={resultadoSorteioState.modalReiniciar}
        onCancel={closeModalReiniciar}
        footer={null}
        destroyOnHidden
      >
        <MensagemModal
          text="Deseja reiniciar o fluxo do resultado do sorteio?"
          action={reiniciarResultado({ value: resultadoSorteioState.idSorteio ?? 0 })}
          close={setModalReiniciarResultadoSorteio(false)}
        />
      </Modal>
      <Modal
        title={"CONTAS FINANCEIRAS COM SALDO"}
        afterClose={calcularResultadoFinal}
        centered
        width={1100}
        open={resultadoSorteioState.modalContasComsaldo}
        onCancel={closeModalContasComSaldo}
        footer={null}
        destroyOnHidden
      >
        <ContasComSaldoModal />
      </Modal>
      <Drawer title="VISUALIZAR PASSOS" placement="right" onClose={onCloseSteps} open={openSteps} getContainer={false}>
        <StepsResultado ordem={resultadoSorteioState.resultadoSorteio.length !== 0 ? resultadoSorteioState.resultadoSorteio[0].ordem : 0} />
      </Drawer>
    </Flex>
  );
};

export default ResultadoSorteio;
